import React from 'react'

import Box from '@mui/material/Box'
import Link from '@mui/material/Link'
import Table from '@mui/material/Table'
import TableHead from '@mui/material/TableHead'
import TableBody from '@mui/material/TableBody'
import TableRow from '@mui/material/TableRow'

// components
import Cell from 'components/atoms/StyledTableCell'
import LocationOpenDates from 'components/shared/LocationOpenDates'
import { useAppSettings } from 'components/shared/SettingsProvider'
import SoftCloseRestrictionNotice from './SoftCloseRestrictionNotice'

// helpers
import { displayPlanDaysRemaining } from 'lib/helpers/account/plans'

const MobilePlanList = props => {
  const {
    plans,
    enableCovidRequirements
    // don't show location dates if covid requirements are enabled
    // (in order to reduce confusion vs reserved week dates)
  } = props

  const { enableReservationsByDay } = useAppSettings()

  return plans.map(plan => (
    <Box key={plan.id} my={2}>
      <Table size='small'>
        <TableHead>
          <TableRow>
            <Cell>Camp Session</Cell>
            <Cell align='right'>{plan.session.name}</Cell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <Cell>Product</Cell>
            <Cell align='right'>{plan.product.description}</Cell>
          </TableRow>
          <TableRow>
            <Cell>Days Remaining</Cell>
            <Cell align='right'>
              {displayPlanDaysRemaining(plan, { label: false })}
            </Cell>
          </TableRow>
          <TableRow>
            <Cell>Days Used</Cell>
            <Cell align='right'>{plan.days.debited}</Cell>
          </TableRow>
          <TableRow>
            <Cell>
              {enableReservationsByDay ? 'Location' : 'Preferred Location'}
            </Cell>
            <Cell align='right'>
              <Link underline='always' href={plan.location.marcomUrl}>
                {plan.location.name}
              </Link>
            </Cell>
          </TableRow>
          {!enableCovidRequirements && (
            <TableRow>
              <Cell>Dates</Cell>
              <Cell align='right'>
                <LocationOpenDates
                  openDate={plan.location.openDate}
                  closeDate={plan.location.closeDate}
                />
              </Cell>
            </TableRow>
          )}
        </TableBody>
      </Table>
      <SoftCloseRestrictionNotice
        restriction={plan.softCloseRestriction}
        sessionId={plan.session.id}
        registeredAt={plan.registeredAt}
      />
    </Box>
  ))
}

export default MobilePlanList
